import {useMutation} from '@tanstack/react-query';
import {OperationStateTypesEnum} from 'presentation/constants/operationStateEnum';
import {postResendEmailOtpCode} from '../../services/postResendEmailOtpCode';
import {ResendEmailOtpMutation} from './types';

export function useResendEmailOtpMutation({setChangingEmailState}: ResendEmailOtpMutation) {
	return useMutation({
		mutationFn: postResendEmailOtpCode,
		onMutate: async () => {
			setChangingEmailState(OperationStateTypesEnum.PENDING);
		},
		onSettled: () => {
			setChangingEmailState(OperationStateTypesEnum.DONE);
		},
	});
}
